// extracted by mini-css-extract-plugin
export var dateLabel = "_3c-0";
export var dateLabelError = "_3c-1";
export var fullWidth = "_3c-2";
export var smaller = "_3c-3";